import { type LineItemBuilder } from "../LineItemUpdate";
import { PackageEntrySource } from "~/feature/cart/cart/models/CartData";
import { type LineItemMessage } from "../common";

const MSG_MISMATCHED_QTY: LineItemMessage = {
  type: "error",
  key: "addToCartPopup.mismatchedQty",
};

const MSG_INVALID_PACKAGE: LineItemMessage = {
  type: "error",
  key: "page.cart.message.error.invalidPackage",
};

export function validateQty(lineItem: LineItemBuilder): void {
  const type = lineItem.get("source");
  const quantity = lineItem.get("quantity");

  lineItem.removeMessage(MSG_MISMATCHED_QTY.key);
  const packSize = lineItem.get("packSize");
  if (packSize !== undefined) {
    const validQty = quantity > 0 && Number.isInteger(quantity / packSize);
    if (!validQty && type !== PackageEntrySource.BULK) {
      lineItem.addMessage(MSG_MISMATCHED_QTY);
    }
  }
}

export function validatePackage(lineItem: LineItemBuilder): void {
  // SCHAEFF-16083 - Treat "XX" package code as PMA product, so "XX" is not an invalid/error causing code anymore
  // const isInvalidPackage = getPackageCode(lineItem.get("packCode")) === INVALID_PACKAGE_CODE;
  lineItem.removeMessage(MSG_INVALID_PACKAGE.key);

  /*
      SCHAEFF-11995 - don't show both
      "addToCartPopup.mismatchedQty"
      and
      "page.cart.message.error.invalidPackage". First has higher priority
   */
  // if (isInvalidPackage && !lineItem.findMessage(MSG_MISMATCHED_QTY.key)) {
  //   lineItem.addMessage(MSG_INVALID_PACKAGE);
  // }
}
